import React, { useState } from "react";
import { FailureDetailsSettingsContext } from "./FailureDetailsSettingsContext";
import { IFailureDetailsSettingsContextProps } from "./FailureDetailsSettingsInterfaces";
import { initialState } from "./FailureDetailsSettingsContext";

export const FailureDetailsSettingsContextProvider: React.FC<IFailureDetailsSettingsContextProps> = ({ children }) => {
    const [selectedFailureTypeId, setSelectedFailureTypeId] = useState<number | null>(
        initialState.selectedFailureTypeId,
    );
    const [selectedFailureCodeId, setSelectedFailureCodeId] = useState<number | null>(
        initialState.selectedFailureCodeId,
    );
    const [selectedAreaId, setSelectedAreaId] = useState<number | null>(initialState.selectedAreaId);
    const [selectedFunctionalLocationId, setSelectedFunctionalLocationId] = useState<number | null>(
        initialState.selectedFunctionalLocationId,
    );
    const [selectedSecondaryFunctionalLocationId, setSelectedSecondaryFunctionalLocationId] = useState<number | null>(
        initialState.selectedFunctionalLocationId,
    );

    const [isSelectedFailureTypeLocationSpecific, setIsSelectedFailureTypeLocationSpecific] = useState<boolean | null>(
        initialState.isSelectedFailureTypeLocationSpecific,
    );

    const handleSelectedFailureTypeId = (value: number | null) => {
        setSelectedFailureTypeId(value);
        setSelectedFailureCodeId(null);
    };

    const handleSelectedFailureCodeId = (value: number | null) => {
        setSelectedFailureCodeId(value);
    };

    const handleSelectedAreaId = (value: number | null) => {
        setSelectedAreaId(value);
    };

    const handleSelectedFunctionalLocationId = (value: number | null) => {
        setSelectedFunctionalLocationId(value);
    };

    const handleSelectedSecondaryFunctionalLocationId = (value: number | null) => {
        setSelectedSecondaryFunctionalLocationId(value);
    };

    const handleIsSelectedFailureTypeLocationSpecific = (value: boolean | null) => {
        setIsSelectedFailureTypeLocationSpecific(value);
    };

    const providerValue = {
        selectedFailureTypeId,
        handleSelectedFailureTypeId,
        selectedFailureCodeId,
        handleSelectedFailureCodeId,
        selectedAreaId,
        handleSelectedAreaId,
        selectedFunctionalLocationId,
        handleSelectedFunctionalLocationId,
        selectedSecondaryFunctionalLocationId,
        handleSelectedSecondaryFunctionalLocationId,
        isSelectedFailureTypeLocationSpecific,
        handleIsSelectedFailureTypeLocationSpecific,
    };

    return (
        <FailureDetailsSettingsContext.Provider value={providerValue}>
            {children}
        </FailureDetailsSettingsContext.Provider>
    );
};
